import { render, staticRenderFns } from "./ItemsForm.vue?vue&type=template&id=06374cbd&scoped=true"
import script from "./ItemsForm.vue?vue&type=script&lang=js"
export * from "./ItemsForm.vue?vue&type=script&lang=js"
import style0 from "./ItemsForm.vue?vue&type=style&index=0&id=06374cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06374cbd",
  null
  
)

export default component.exports